/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionVulnerability {
    getFixupPrototypeFunction() { return AppSecopsSbomVersionVulnerability.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionVulnerability>): AppSecopsSbomVersionVulnerability {
        let obj = Object.assign(new AppSecopsSbomVersionVulnerability(), model);
        AppSecopsSbomVersionVulnerability.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionVulnerability>): AppSecopsSbomVersionVulnerability {
        if (!model) return null;
        return AppSecopsSbomVersionVulnerability.newInstance(<AppSecopsSbomVersionVulnerability> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionVulnerability) {
        if (!obj) return;

        models.AppSecopsSbomVersionVulnerability.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionVulnerability): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomVersionVulnerability.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.sbom_vulnerability_details_by_tenant) {
            models.AppSecopsSbomVulnerabilityDetailsByTenant.fixupPrototype(this.sbom_vulnerability_details_by_tenant);
        }
        if (this.components) {
            for (let val of this.components) {
                models.AppSecopsSbomVulnerabilityComponentDetail.fixupPrototype(val);
            }
        }
        if (this.risk_score_by_application) {
            for (let val of this.risk_score_by_application) {
                models.AppSecopsSbomVersionRiskScore.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique ID of the vulnerabilities associated to the SBOM version.
     */
    sbom_version_vulnerability_id: string;

    /**
     * Unique ID of the SBOM version
     */
    sbom_version_id: string;

    /**
     * Unique ID for the global vulnerability reference.
     */
    vulnerability_id: string;

    /**
     * List of affected SBOM components.
     */
    components: Array<models.AppSecopsSbomVulnerabilityComponentDetail>;

    /**
     * Risk score of the vulnerability by application.
     */
    risk_score_by_application: Array<models.AppSecopsSbomVersionRiskScore>;

    /**
     * Tenant ID associated with the vulnerability
     */
    tenant_id: string;

    /**
     * Tenant ID to which the SBOM belongs to.
     */
    sbom_vulnerability_details_by_tenant: models.AppSecopsSbomVulnerabilityDetailsByTenant;

}
